import { render, staticRenderFns } from "./menu_recherches.vue?vue&type=template&id=cf7bf32a"
import script from "./menu_recherches.js?vue&type=script&lang=js&external"
export * from "./menu_recherches.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports